
import { defineComponent, SetupContext, PropType } from "vue";
import TopicListItem from "./TopicListItem.vue";
import { Recipes } from "@/types/recipes";

export default defineComponent({
  name: "TopicList",
  components: { TopicListItem },
  props: {
    /**
     * レシピリストに表示するデータの配列
     */
    recommendRecipes: {
      type: Array as PropType<Recipes[]>,
      default: () => null
    },
    /**
     * レシピ種別
     */
    type: {
      type: String,
      default: "",
      required: true
    }
  },
  setup(props, context: SetupContext) {
    /**
     * レシピ押下時に id と type を通知する
     *
     * @param {number} id - レシピID
     * @param {string} type - レシピの種別
     */
    const selectRecipe = (id: number, type: string) => {
      context.emit("on-click", id, type);
    };

    /**
     * レシピリストを取得する
     */
    const getRecipes = (recipes: Recipes) => {
      if (recipes != null && recipes.recipes != null) {
        return recipes.recipes;
      } else {
        return null;
      }
    };

    return {
      selectRecipe,
      getRecipes
    };
  }
});
